import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import { RoutesComponent } from "./Routes";
import { SocketContext } from "./components/SocketContext";


const App = () => {

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const url = process.env.REACT_APP_API_URL || 'https://twibbleserver-d70b8a5837f9.herokuapp.com/';
    const newSocket = io(url);
    //const newSocket = io('https://twibbleserver-d70b8a5837f9.herokuapp.com/');
    setSocket(newSocket);

    newSocket.on("close", () => {
      console.log('Got close event'); // false
    });

    newSocket.io.on("disconnect", () => {
      console.log('Got disconnected'); // false
    });

    newSocket.io.on("reconnect_error", () => {
      console.log('Got disconnected2'); // false
    });
    
    newSocket.io.on("disconnnect", () => {
      console.log('Got manager disconnected2'); // false
    });

    return () => newSocket.close();
  }, []);


  return <SocketContext.Provider value={socket}><RoutesComponent /></SocketContext.Provider>;
};

export default App;